export const GUIDE = [
  {
    id: "demarrer",
    title: "1. Démarrer",
    items: [
      "Connectez-vous avec votre compte (flodec75@gmail.com). Le tableau de bord s'ouvre : nombre de prospects, valeur du pipeline, taux de conversion, taux d'ouverture des emails et liste des « Prospects chauds » (ceux qui ont ouvert vos emails).",
      "Le menu de gauche donne accès à toutes les sections : Prospection, Pipeline CRM, Relances, Modèles IA, Carte, Paramètres.",
      "Le bouton « Exporter CSV » (Dashboard et Pipeline) télécharge tous vos prospects dans un fichier compatible Excel.",
    ],
  },
  {
    id: "prospection",
    title: "2. Trouver de vraies entreprises (Prospection)",
    items: [
      "Choisissez un département d'Île-de-France, éventuellement une ville (ex. Morsang-sur-Orge), un secteur (commerces, PME, santé, juridique, éducation, restauration) et un nombre de résultats (max 25).",
      "Cliquez « Lancer la prospection » : l'outil interroge le registre officiel SIRENE (entreprises actives, PME/TPE) puis complète téléphone / site web via OpenStreetMap quand ils existent (badge « Contact vérifié OSM »).",
      "Les entreprises déjà présentes dans votre pipeline sont ignorées automatiquement. « Chercher plus » passe à la page suivante pour en découvrir d'autres.",
      "L'email des entreprises n'est pas public : pour ces prospects, privilégiez le téléphone et le script d'appel généré par l'IA. Le bouton « Trouver des emails » (Pipeline) et « Trouver l'email (site web) » (fiche) analysent les sites web des entreprises et y récupèrent les emails / téléphones publiés quand ils existent.",
      "Les particuliers (B2C) s'ajoutent via le formulaire « Ajouter manuellement » ou par import CSV (colonnes : company, contact_name, phone, email, city, sector).",
    ],
  },
  {
    id: "pipeline",
    title: "3. Suivre ses prospects (Pipeline CRM)",
    items: [
      "Le pipeline est un tableau Kanban : Nouveaux → Contactés → RDV → Gagnés / Perdus. Glissez-déposez une carte pour changer d'étape.",
      "Une flamme orange sur une carte signale un prospect qui a ouvert un de vos emails : à relancer en priorité.",
      "La barre de recherche filtre par entreprise, contact ou ville. Cliquez une carte pour ouvrir la fiche détaillée.",
    ],
  },
  {
    id: "fiche",
    title: "4. La fiche prospect",
    items: [
      "En haut : coordonnées, étape (modifiable), valeur estimée, tags (activité, effectif, année de création). Les notes se saisissent dans le panneau de droite.",
      "Générateur IA : choisissez le type (email, script d'appel, relance, offre), le ton et le modèle (Claude Sonnet 5 ou GPT 5.6), ajoutez un contexte si besoin, puis « Générer ». Le texte est signé automatiquement PC UP avec vos coordonnées.",
      "« Modifier » permet de retoucher le texte ; « Copier » le met dans le presse-papiers ; « Sauver comme modèle » le conserve pour le réutiliser en un clic sur d'autres prospects (les noms d'entreprise, contact, ville sont remplacés automatiquement).",
      "L'historique IA en bas de fiche conserve tous les messages générés.",
    ],
  },
  {
    id: "envoi",
    title: "5. Envoyer un email",
    items: [
      "Prospection à froid (entreprise trouvée par la recherche) → « Envoyer depuis ma messagerie (contact@pcup.fr) » : votre messagerie s'ouvre avec destinataire, objet et texte pré-remplis (le texte est aussi copié). Vous envoyez vous-même depuis votre boîte OVH. Le prospect passe en « Contactés » et une relance à J+3 est créée.",
      "Échange transactionnel (le prospect vous a donné son email, ou il est en RDV / Gagné) → cochez « Email communiqué par le prospect », puis « Aperçu » pour voir l'email exact (logo, signature) et « Envoyer ». Ces envois sont suivis : vous saurez quand l'email est ouvert.",
      "Si votre boîte OVH est connectée (Paramètres), ces envois partent de contact@pcup.fr ; sinon ils partent de la plateforme avec « PC UP » comme nom d'expéditeur et contact@pcup.fr en adresse de réponse.",
      "Les réponses des prospects arrivent toujours sur contact@pcup.fr.",
    ],
  },
  {
    id: "relances",
    title: "6. Relances",
    items: [
      "La page Relances liste vos tâches avec échéance et priorité. Créez-en manuellement ou laissez l'outil le faire : après un envoi depuis votre messagerie (J+3) et dès qu'un prospect ouvre un email (priorité haute, J+1).",
      "Cochez une tâche pour la terminer. Le compteur de relances en attente apparaît sur le tableau de bord.",
    ],
  },
  {
    id: "modeles",
    title: "7. Modèles IA",
    items: [
      "Retrouvez tous vos messages sauvegardés, filtrez par type, renommez ou éditez le contenu, supprimez. Le compteur indique combien de fois chaque modèle a été utilisé.",
      "Variables disponibles : {{entreprise}}, {{contact}}, {{prenom}}, {{ville}} — remplacées automatiquement à l'application sur un prospect.",
    ],
  },
  {
    id: "carte",
    title: "8. Carte",
    items: [
      "Tous les prospects géolocalisés apparaissent sur la carte d'Île-de-France, colorés par étape ; un contour épais indique une ouverture d'email.",
      "Filtrez par étape ou département, consultez les villes les plus denses pour organiser vos tournées, cliquez un point puis « Ouvrir la fiche ».",
      "Les prospects saisis à la main sans coordonnées peuvent être positionnés avec le bouton « Positionner … prospect(s) ».",
    ],
  },
  {
    id: "parametres",
    title: "9. Paramètres — connecter la boîte OVH",
    items: [
      "Serveur ssl0.ovh.net, port 465 (SSL), identifiant contact@pcup.fr, mot de passe de la boîte (espace client OVH → Emails → Comptes). Enregistrez puis « Tester la connexion » ; « Envoyer un email test » vérifie la réception.",
      "Le mot de passe est stocké chiffré et n'est jamais renvoyé au navigateur. « Supprimer la configuration » rebascule les envois sur la plateforme.",
    ],
  },
  {
    id: "bonnes-pratiques",
    title: "10. Bonnes pratiques",
    items: [
      "Prospection B2B par email : adressez-vous à des professionnels pour des services liés à leur activité, et proposez toujours une possibilité de refus (la signature PC UP le permet). Évitez les envois massifs.",
      "Un prospect qui ouvre deux fois votre email sans répondre mérite un appel : utilisez le script d'appel généré par l'IA.",
      "Exportez régulièrement en CSV pour vos reportings ou votre comptabilité.",
    ],
  },
];
